module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am609-52ab7f35022061d6c3b7a86c3712573f.jpg";